import { Injectable } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class ChunkErrorHandler {
  constructor(router: Router) {
    router.events
      .pipe(filter((event) => event instanceof NavigationError))
      .subscribe((event: NavigationError) => {
        if (this.isChunkLoadError(event)) {
          window.location.href = `${window.location.origin}${event.url}`;
        }
      });
  }

  private isChunkLoadError(event: NavigationError) {
    return event.error.name === 'ChunkLoadError';
  }
}
